import React from 'react';
import GoogleIcon from '../../images/GoogleIcon';

/**
 * The icon and label are direct children of the flex row on purpose.
 *
 * They used to sit inside a plain block `<div>` and rely on the SVG defaulting
 * to `display: inline` to stay on one line. The design system's stylesheet
 * ships Tailwind Preflight, which sets `svg { display: block }` — so the logo
 * took a line of its own and pushed the label onto a second one.
 */
const GoogleLoginButton = ({ onClick = () => {} }) => (
  <div
    onClick={onClick}
    style={{
      height: '38px',
      backgroundColor: '#fff',
      border: '1px solid #dadce0',
      borderRadius: '4px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 9,
      padding: '0 12px',
      cursor: 'pointer',
    }}
  >
    <GoogleIcon width="18px" height="18px" />
    <span
      style={{
        fontFamily: 'Google Sans,arial,sans-serif',
      }}
    >
      Sign in with Google
    </span>
  </div>
);

export default GoogleLoginButton;
